export enum ApiSourceType {
	First = 'First',
	Second = 'Second'
}
